import React from "react";
import Select from "react-select";

export default function DarkModeSelect({ options, value, onChange }) {
    const isDarkMode = true;

    const customTheme = (theme) => ({
        ...theme,
        colors: {
            ...theme.colors,
            neutral0: isDarkMode ? "#1f2937" : "#ffffff",
            primary25: isDarkMode ? "#374151" : "#f3f4f6",
            neutral80: isDarkMode ? "#ffffff" : "#000000",
        },
    });

    const baseStyles = {
        control: (base) => ({
            ...base,
            backgroundColor: isDarkMode ? "#1f2937" : "#ffffff",
            borderColor: isDarkMode ? "#374151" : "#d1d5db",
            color: isDarkMode ? "#fff" : "#000",
            minHeight: "40px",
        }),
        singleValue: (base) => ({
            ...base,
            color: isDarkMode ? "#fff" : "#000",
        }),
        input: (base) => ({
            ...base,
            color: isDarkMode ? "#fff" : "#000",
        }),
        placeholder: (base) => ({
            ...base,
            color: isDarkMode ? "#9ca3af" : "#6b7280",
        }),
    };

    return (
        <Select
            value={value}
            onChange={onChange}
            options={options}
            styles={baseStyles}
            theme={customTheme}
            placeholder="Select..."
        />
    );
}
